<template>
  <div>
    <table class="table borderless">
      <tbody>
        <tr>
          <td>Название</td>
          <td>
            <input
              v-model="supplier.name"
              type="text"
              class="form-control"
              placeholder
              required
            >
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'SupplierEdit',
  props: {
    supplier: {
      type: Object,
      default: () => null
    },
  },
}
</script>
